import * as React from 'react';
import HelpPage from '../help/HelpPage';
import mdFile from '../help/MappingTables.md'

export default function ChemistryHelpPage(props = {}) {

  return (
    <HelpPage
      previousPage="/chemistry/list"
      pageName="Chemistry Help"
      mdFile={mdFile}
      {...props}
    />
  )
}